import { useState } from "react";
import { faqList } from "@/mocks/portal";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/60">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-secondary-700 ring-1 ring-background-200">
            <i className="ri-question-line" />
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">你可能想问</h2>
        </div>

        <div className="mt-8 space-y-3">
          {faqList.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-foreground-950">{item.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform ${isOpen ? "rotate-45" : ""}`}
                  >
                    <i className="ri-add-line" />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}